export const SHOW_SNACKBAR = 'show_snackbar';
export const RESET_SHOW_SNACKBAR = 'reset_show_snackbar';
